var _style, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRightArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    width: 32,
    height: 32,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "leftArrow-svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: #ffffff } \n\t\t.s1 { fill: #6a27ea } \n\t\t.s2 { fill: none;stroke: #6a27ea;stroke-width: .5 } \n\t")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m31 16.1c-0.1 8.3-6.8 15-15.1 14.9-8.3-0.1-15-6.8-14.9-15.1 0.1-8.3 6.8-15 15.1-14.9 8.3 0.1 15 6.8 14.9 15.1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m10.9 16.3c-0.2 0-0.3-0.2-0.3-0.3 0-0.2 0.1-0.3 0.3-0.3zm8.5 1.8c-0.1 0.2-0.3 0.2-0.4 0-0.1-0.1-0.1-0.3 0-0.4l1.7-1.7-1.7-1.7c-0.1-0.1-0.1-0.3 0-0.4 0.1-0.1 0.3-0.1 0.4 0l1.9 1.9c0.1 0.1 0.1 0.3 0 0.4zm1.7-1.8h-10.2v-0.6h10.2z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s2",
    d: "m31 16.1c-0.1 8.3-6.8 15-15.1 14.9-8.3-0.1-15-6.8-14.9-15.1 0.1-8.3 6.8-15 15.1-14.9 8.3 0.1 15 6.8 14.9 15.1z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/rightArrow.6e3aa63bfc769ac125134112c512d7b9.svg";
export { ForwardRef as ReactComponent };